import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PHYSICAL_ADDRESS_CONFIG } from '@rd/core/tokens/physical-address.token';
import { PhysicalAddressFacade } from './facades/physical-address-facade/physical-address.facade';
import { PhysicalAddressEffects } from './store/effects/physical-address.effects';
import { reducers } from './store/reducers/index';
import { PhysicalAddressConfiguration } from './types';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('physicalAddress', reducers),
    EffectsModule.forFeature([PhysicalAddressEffects]),
  ],
  providers: [PhysicalAddressFacade],
})
export class PhysicalAddressModule {
  static forRoot(config: {
    physicalAddressConfig: PhysicalAddressConfiguration;
  }): ModuleWithProviders<PhysicalAddressModule> {
    return {
      ngModule: PhysicalAddressModule,
      providers: [
        {
          provide: PHYSICAL_ADDRESS_CONFIG,
          useValue: config.physicalAddressConfig,
        },
      ],
    };
  }
}
